/**
 * @deprecated import colors from @addi/foundation/dist/web/colors instead
 */
const White = {
    normal: '#ffffff'
};
export default White;
//# sourceMappingURL=white.js.map